import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FileUploadModule } from 'primeng/fileupload';
import { ProgressBarModule } from 'primeng/progressbar';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CheckboxModule } from 'primeng/checkbox';
import { TabViewModule } from 'primeng/tabview';
import { MenuModule } from 'primeng/menu';

import { ImportsRoutingModule } from './imports-routing.module';
import { ImportsListComponent } from './imports-list/imports-list.component';
import { ImportsCreateComponent } from './imports-create/imports-create.component';
import { ImportsDetailComponent } from './imports-detail/imports-detail.component';

import { CoreModule } from 'src/app/core/core.module';
@NgModule({ declarations: [ImportsListComponent, ImportsCreateComponent, ImportsDetailComponent], imports: [CoreModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ImportsRoutingModule,
        TableModule,
        ButtonModule,
        DropdownModule,
        DialogModule,
        InputSwitchModule,
        FileUploadModule,
        ProgressBarModule,
        TagModule,
        TooltipModule,
        ConfirmDialogModule,
        CheckboxModule,
        TabViewModule,
        MenuModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ImportsModule { }
